export default "__VITE_ASSET__8d6eaab2__"